import request from '@/utils/request'

const prefix = '/django_rest/company'

export default {
  getCompanySourceCode (params) {
    return request.get(`${prefix}/source-code/`, { params })
  },
  getSourceChannelList (params) {
    return request.get('/django_rest/source_channel/', { params })
  },
  updateSourceChannelStatus (data) {
    return request.put('/django_rest/source_channel/', data)
  },
  saveSourceChannel (data) {
    return request.post('/django_rest/source_channel/', data)
  },
  getSourceCodeList (params) {
    return request.get('/django_rest/tagged_source/', { params })
  },
  getSourceCodeById (sourceCodeId, params) {
    return request.get(`/django_rest/tagged_source/${sourceCodeId}`, { params })
  },
  updateSourceCodeById (sourceCodeId, data) {
    return request.put(`/django_rest/tagged_source/${sourceCodeId}`, data)
  },
  saveSourceCode (data) {
    return request.post('/django_rest/tagged_source/', data)
  }
}
